/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration, identity } from '@gh/core-data';
import { JobContractStartBasedOnType } from '../system-vars/system-vars.dto';
import { CriticalPathDetailsDto, CriticalPathSaveDto } from './critical-path.dto';

export const CriticalPathDetailsMapper = entity<CriticalPathDetailsDto>({
  contractStartBasedOn: enumeration(JobContractStartBasedOnType),
  warningMessage: identity(),
});
export const CriticalPathSaveMapper = entity<CriticalPathSaveDto>({});
